import * as yup from 'yup';
import { IAquaConfiguration } from '../aqua';
import { IName, NameSchema } from './IName';

export const NursingHomeSchema = yup.object({
  name: yup.string().required(),
});

export interface INursingHome {
  name: string;
  aquaConfiguration?: IAquaConfiguration;
}

export const CreateNursingHomeSchema = yup
  .object({
    userName: NameSchema.required(),
    userPin: yup.string().min(6, 'min-length').matches(/^\d+$/).required(),
  })
  .concat(NursingHomeSchema);

export interface ICreateNursingHome {
  name: string;
  userName: IName;
  userPin: string;
}
